import React, {
  Component
} from 'react';
import NavBar from '../../Components/NavBar/NavBar';
import AuthCheck from '../../Components/Utils/AuthCheck'
import ProfileCard from './ProfileCard/ProfileCard';

export default class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    AuthCheck(this.props);

  }

  render() {
    document.title = 'Xtendliving | Admin | User Information';
    const {
      user
    } = this.props.location.state;
    return (
      <div style={{marginBottom:50}}>
        <NavBar loggedIn={true}/>
        <ProfileCard user={user}/>
        <div className="container center">
          <h3>User Information...work in progress</h3>
        </div>
      </div>
    )
  }
}